const Weddings=[
	{
		id: 1,
		title: "GOLD",
		fee: '5,000',
		description: "ENGAGEMENT & RECEPTION ONLY",
		detail1: '2 Videographers',
		detail2: '1 minute trailer',
		detail3: '50 min. Full video on a flash drive'
	},
	{
		id: 2,
		title: "PLATINUM",
		fee: '6,500',
		description: "ENGAGEMENT & RECEPTION ONLY",
		detail1: '3 Videographers and a Drone',
		detail2: '2 min and above trailer',
		detail3: 'Full-length video on a flash drive'
	}
]


export default Weddings;